import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./HeaderStyles";

export default class Header extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div
        className={css([
          styles.header,
          this.props.loggedOut && styles.loggedOut,
          this.props.isAssistedLiving && styles.headerAssistedLiving,
          this.props.isSetup && styles.headerSetup,
          this.props.step > 0 &&
            this.props.stage === 1 &&
            styles.headerMainSetup,
          this.props.step > 0 &&
            this.props.stage === 2 &&
            styles.headerAssistedSetup
        ])}
      >
        <div className={css(styles.headerInner)}>
          {this.props.backHref && (
            <a
              href={this.props.backHref}
              className={css([
                this.props.isSetup ? styles.close : styles.back,
                this.props.loggedOut && styles.backLoggedOut
              ])}
            >
              <strong
                className={css([
                  styles.back__title,
                  this.props.loggedOut && styles.back__titleLoggedOut
                ])}
              >
                {this.props.backTitle}
              </strong>
            </a>
          )}
          <h1
            className={css([
              styles.title,
              this.props.loggedOut && styles.titleLoggedOut
            ])}
          >
            {this.props.isAssistedLiving && (
              <img
                src="/infocare-logo.svg"
                alt=""
                className={css(styles.infoCareLogo)}
              />
            )}
            {this.props.isHomeView && (
              <img
                src="/homeview-logo.svg"
                alt=""
                className={css(styles.homeViewLogo)}
              />
            )}
            {!this.props.isAssistedLiving &&
              !this.props.isHomeView &&
              this.props.title}
          </h1>
          {!this.props.isSetup && !this.props.hideAccount && (
            <a
              href={`/account/${
                this.props.isAssistedLiving ? "?tab=assisted" : ""
              }`}
              className={css(styles.account)}
            >
              <strong className={css(styles.account__title)}>Account</strong>
              <img
                src={"/icons/AccountIcon.svg"}
                alt=""
                className={css(styles.account__icon)}
              />
            </a>
          )}
          {this.props.hideAccount && <div className={css(styles.account)} />}
        </div>
      </div>
    );
  }
}
